import type { CSSProperties } from 'react';
import SearchIconSvg from '../../assets/icons/search.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const SearchIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        ...style,
    };

    return <SearchIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default SearchIcon;
